import type { Facing, Pose } from '../render/sprites';

/** Animation state shared by the player and NPCs. */
export class Actor {
  facing: Facing = 'down';
  phase = 0;
  moving = false;
  down = false;
  private blinkIn = 2 + Math.random() * 3;
  private blinkFor = 0;
  private breath = Math.random();

  constructor(
    public x: number,
    public y: number,
  ) {}

  /** Advance animation; `dx, dy` is the distance moved this frame. Returns true on a footstep. */
  animate(dt: number, dx: number, dy: number): boolean {
    this.breath = (this.breath + dt / 1.6) % 1;
    if (this.blinkFor > 0) this.blinkFor -= dt;
    else if ((this.blinkIn -= dt) <= 0) {
      this.blinkFor = 0.12;
      this.blinkIn = 2.5 + Math.random() * 3.5;
    }
    const dist = Math.hypot(dx, dy);
    this.moving = dist > 0.01;
    if (!this.moving) {
      this.phase = 0;
      return false;
    }
    if (Math.abs(dx) > Math.abs(dy) * 1.1) this.facing = dx < 0 ? 'left' : 'right';
    else this.facing = dy < 0 ? 'up' : 'down';
    const before = this.phase;
    // One full stride every 14px so feet don't slide over the ground.
    this.phase = (this.phase + dist / 14) % 1;
    // A footstep lands at each half cycle.
    return Math.floor(before * 2) !== Math.floor(this.phase * 2) || this.phase < before;
  }

  face(tx: number, ty: number): void {
    const dx = tx - this.x, dy = ty - this.y;
    if (Math.abs(dx) > Math.abs(dy)) this.facing = dx < 0 ? 'left' : 'right';
    else this.facing = dy < 0 ? 'up' : 'down';
  }

  pose(): Pose {
    return { facing: this.facing, phase: this.phase, moving: this.moving, blink: this.blinkFor > 0, breath: this.breath, down: this.down };
  }
}
